import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import PhoneInput from 'react-phone-number-input';
import Select from 'react-select';
import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import { getTokenInfo } from '../../../../UseToken';
import Loader from '../../../Loader/Loader';
import Swal from 'sweetalert2'
import Hosts from '../../../../Hosts';
import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	pattern_email,
} from '../../../../Utils';

import { language } from './Language';
import { color } from '../../../WEBContent/Color';

const modalStyles = {
	modalOverlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		backgroundColor: color.corShadow.rgba2,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: 1000,
	},
	modalContent: {
		backgroundColor: color.cor3.hexa,
		padding: '20px',
		borderRadius: '10px',
		width: '600px',
		maxWidth: '90%',
		textAlign: 'center',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		position: 'relative',
		overflow: 'hidden',
	},
	taskListContainer: {
		flex: 1,
		width: '100%',
		padding: '10px 15px',
		textAlign: 'start',
	},
	buttonContainer: {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		marginTop: '15px',
	},
	closeButton: {
		padding: '10px 20px',
		border: 'none',
		borderRadius: '5px',
		cursor: 'pointer',
		backgroundColor: color.cor1.hexa,
		fontSize: '16px',
	},
};

// Mesma lista de modalidades usada no módulo das Competições
const modalidades_lista = [
	{ value: 'ski_de_fundo', label: 'Esqui de Fundo' },
	{ value: 'curling', label: 'Curling' },
	{ value: 'ski_alpino', label: 'Esqui Alpino' },
	{ value: 'bobsled', label: 'Bobsled' },
	{ value: 'hoquei_no_gelo', label: 'Hóquei no Gelo' },
	{ value: 'luge', label: 'Luge' },
	{ value: 'snowboard', label: 'Snowboard' },
	{ value: 'skeleton', label: 'Skeleton' },
	{ value: 'patinagem_artistica', label: 'Patinagem Artística' },
	{ value: 'patinagem_de_velocidade', label: 'Patinagem de Velocidade' },
	{ value: 'ski_freestyle', label: 'Esqui Free Style' },
	{ value: 'biatlo', label: 'Biatlo' },
];

const tipo_convocatoria_lista = [
	{ value: 'competicao', label: 'Competição' },
	{ value: 'estagio', label: 'Estágio' },
	{ value: 'estagio_competicao', label: 'Estágio + Competição' },
];

// ================= TABELAS DE ESCALÃO (idênticas às Competições) =================
const ESCALOES_GERAL = [
	{ id: 'U10', label: 'U10', min: 2016, max: Infinity },
	{ id: 'U12', label: 'U12', min: 2014, max: 2015 },
	{ id: 'U14', label: 'U14', min: 2012, max: 2013 },
	{ id: 'U16', label: 'U16', min: 2010, max: 2011 },
	{ id: 'U18', label: 'U18', min: 2008, max: 2009 },
	{ id: 'U21', label: 'U21', min: 2005, max: 2007 },
	{ id: 'SENIOR', label: 'Sénior', min: 1991, max: 2004 },
	{ id: 'M35', label: 'M35', min: 1971, max: 1990 },
	{ id: 'M55', label: 'M55', min: -Infinity, max: 1970 },
];

const ESCALOES_SNOWBOARD = [
	{ id: 'U9', label: 'U9 (kids)', min: 2017, max: Infinity },
	{ id: 'U11', label: 'U11 (SuperGrom)', min: 2015, max: 2016 },
	{ id: 'U13', label: 'U13 (SuperGrom)', min: 2013, max: 2014 },
	{ id: 'U15', label: 'U15 (Grom)', min: 2011, max: 2012 },
	{ id: 'U18_ROOKIE', label: 'U18 (Rookie)', min: 2008, max: 2010 },
	{ id: 'ABSOLUTO', label: 'Absoluto', min: 1985, max: 2007 },
	{ id: 'M40', label: 'M40 (Master)', min: -Infinity, max: 1984 },
];

const ESCALOES_PATINAGEM = [
	{ id: 'PRE_INICIADO', label: 'Pré-Iniciado' },
	{ id: 'NOVATOS', label: 'Novatos' },
	{ id: 'JUNIORES', label: 'Juniores' },
	{ id: 'SENIORES', label: 'Seniores' },
	{ id: 'ADULTOS', label: 'Adultos' },
];

const escaloes_lista = [
	...ESCALOES_GERAL.map(e => ({ value: e.id, label: e.label })),
	...ESCALOES_SNOWBOARD.map(e => ({ value: e.id, label: `${e.label} (Snowboard)` })),
	...ESCALOES_PATINAGEM.map(e => ({ value: e.id, label: `${e.label} (Patinagem)` })),
];

const anoNascimento = (birthday) => {
	if (!birthday) return null;
	const ano = parseInt(String(birthday).slice(0, 4), 10);
	return Number.isNaN(ano) ? null : ano;
};

const escalaoPorAno = (ano, tabela) => {
	if (ano === null) return '';
	const item = tabela.find(e => ano >= e.min && ano <= e.max);
	return item ? item.id : '';
};

const idadeReferencia = (birthday, anoEpoca) => {
	if (!birthday) return null;
	const nascimento = new Date(birthday);
	const referencia = new Date(anoEpoca, 6, 1);
	let idade = referencia.getFullYear() - nascimento.getFullYear();
	const diffMes = referencia.getMonth() - nascimento.getMonth();
	if (diffMes < 0 || (diffMes === 0 && referencia.getDate() < nascimento.getDate())) idade--;
	return idade;
};

const escalaoPorIdade = (idade) => {
	if (idade === null) return '';
	if (idade >= 28) return 'ADULTOS';
	if (idade > 13 && idade <= 18) return 'JUNIORES';
	if (idade >= 8 && idade <= 13) return 'NOVATOS';
	if (idade >= 17) return 'SENIORES';
	if (idade >= 6) return 'PRE_INICIADO';
	return '';
};

const detectarGrupoModalidade = (modalidade_value) => {
	const v = (modalidade_value ?? '').toString().toLowerCase();
	if (v.includes('patinacao')) return 'patinagem';
	if (v.includes('snowboard')) return 'snowboard';
	return 'geral';
};

const getAnoEpocaAtual = () => {
	const hoje = new Date();
	const anoAtual = hoje.getFullYear();
	const mesAtual = hoje.getMonth();
	return mesAtual >= 6 ? anoAtual : anoAtual - 1;
};

const calcular_escalao_para_modalidade = (entidade, modalidade_value) => {
	const birthday = entidade?.info?.birthday ?? entidade?.birthday
	const grupo = detectarGrupoModalidade(modalidade_value)
	const anoEpoca = getAnoEpocaAtual()

	if (grupo === 'patinagem') {
		return escalaoPorIdade(idadeReferencia(birthday, anoEpoca))
	}
	const tabela = grupo === 'snowboard' ? ESCALOES_SNOWBOARD : ESCALOES_GERAL
	return escalaoPorAno(anoNascimento(birthday), tabela)
};

const get_modalidades_entidade = (entidade) => {
	const mods = entidade?.info?.modalidades ?? entidade?.modalidades
	return Array.isArray(mods) ? mods.map(m => (m.value ?? m)) : []
};

const get_overlapping_modalidades = (entidade, modalidades_convocatoria) => {
	const mods_entidade = get_modalidades_entidade(entidade)
	if (!modalidades_convocatoria || modalidades_convocatoria.length === 0) return mods_entidade
	return mods_entidade.filter(m => modalidades_convocatoria.includes(m))
};

const entidade_pratica_modalidade = (entidade, modalidades_convocatoria) => {
	if (!modalidades_convocatoria || modalidades_convocatoria.length === 0) return true
	return get_overlapping_modalidades(entidade, modalidades_convocatoria).length > 0
};

const calcular_escalao_entidade = (entidade, modalidades_convocatoria) => {
	const overlapping = get_overlapping_modalidades(entidade, modalidades_convocatoria)
	return calcular_escalao_para_modalidade(entidade, overlapping[0])
};

const entidade_esta_no_escalao = (entidade, modalidades_convocatoria, escaloes_convocatoria) => {
	if (!escaloes_convocatoria || escaloes_convocatoria.length === 0) return true
	const overlapping = get_overlapping_modalidades(entidade, modalidades_convocatoria)
	if (overlapping.length === 0) return false
	return overlapping.some(m => escaloes_convocatoria.includes(calcular_escalao_para_modalidade(entidade, m)))
};

// Categorias de "pessoas" simples (sem filtro de modalidade/escalão) —
// Agentes Desportivos / Treinadores / Dirigentes
const PERSON_CATEGORIES = {
	agentes_desportivos: { field: 'agentes_desportivos_inscritos', label_key: 'agentes_desportivos', title_key: 'listagem_agentes' },
	treinadores: { field: 'treinadores_inscritos', label_key: 'treinadores', title_key: 'listagem_treinadores' },
	dirigentes: { field: 'dirigentes_inscritos', label_key: 'dirigentes', title_key: 'listagem_dirigentes' },
};

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0);

	const [show_delete_button, set_show_delete_button] = useState(false);
	const [is_edit, set_is_edit] = useState(false);

	// Documentos (Relatório)
	const [files_doc, set_files_doc] = useState([]);

	// ===== Lista de Competições existentes (para o select) =====
	const [competicoes_lista, set_competicoes_lista] = useState([]);

	const fetch_competicoes_lista = async () => {
		try {
			// NOTA: assumindo o mesmo padrão do api_list_route do Config.js das
			// Convocatórias, mas para o type "competicoes". Ajustar se o endpoint
			// real das Competições for diferente.
			const res = await reqGET(`${Hosts.SIMCore_API}/intranet/components/type/${getTokenInfo().companycode}/competicoes`)
			set_competicoes_lista(res.data || [])
		} catch (error) {
			console.error('Erro ao carregar lista de competições:', error)
		}
	}

	useEffect(() => {
		fetch_competicoes_lista()
	}, [])

	// ===== Modal "Inscrever Clube" =====
	const [showClubeModal, setShowClubeModal] = useState(false);
	const [clubeSearch, setClubeSearch] = useState('');
	const [clubeResults, setClubeResults] = useState([]);
	const [clubeLoading, setClubeLoading] = useState(false);
	const [selectedClubeToInscrever, setSelectedClubeToInscrever] = useState(null);
	const [selected_clube_inscrito, set_selected_clube_inscrito] = useState(null);

	// ===== Modal "Inscrever Atletas" =====
	const [showAtletaModal, setShowAtletaModal] = useState(false);
	const [atletaSearch, setAtletaSearch] = useState('');
	const [atletaResults, setAtletaResults] = useState([]);
	const [atletaLoading, setAtletaLoading] = useState(false);
	const [selectedAtletaToInscrever, setSelectedAtletaToInscrever] = useState(null);

	// ===== Modal genérico "Inscrever Pessoa" (agentes/treinadores/dirigentes) =====
	const [showPersonModal, setShowPersonModal] = useState(false);
	const [personCategory, setPersonCategory] = useState(null);
	const [personSearch, setPersonSearch] = useState('');
	const [personResults, setPersonResults] = useState([]);
	const [personLoading, setPersonLoading] = useState(false);
	const [selectedPerson, setSelectedPerson] = useState(null);

	const [clube_ids, set_clube_ids] = useState(new Set());

	const fetch_clube_ids = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/Clube`)
			set_clube_ids(new Set((res.data || []).map(e => String(e.id))))
		} catch (error) {
			console.error('Erro ao carregar lista de clubes:', error)
		}
	}

	useEffect(() => {
		fetch_clube_ids()
	}, [])

	// Garante que todos os campos usados pelo formulário existem, mesmo que o
	// data_interface do Config.js ainda não os tenha definidos.
	const ensure_defaults = (d) => {
		const evento_defaults = {
			data_saida: '',
			inicio: '',
			fim: '',
			local: '',
			localidade: '',
			pais: '',
			data_chegada: '',
		}

		const info_defaults = {
			name: '',
			competicao_id: '',
			competicao_label: '',
			tipo_convocatoria: '', // 'competicao' | 'estagio' | 'estagio_competicao'
			modalidade: '',
			escaloes: [],
			epoca: '',
			estagio: { ...evento_defaults },
			competicao_evento: { ...evento_defaults },
			regulamento: [],
			relatorio: [],
			observacoes: '',
			clubes_inscritos: [],
			atletas_inscritos: [],
			agentes_desportivos_inscritos: [],
			treinadores_inscritos: [],
			dirigentes_inscritos: [],
			responsavel: {
				identificacao: '',
				telefone: '',
				email: '',
			},
		}
		d.info = { ...info_defaults, ...d.info }
		Object.keys(info_defaults).forEach(k => {
			if (d.info[k] === null || d.info[k] === undefined) {
				d.info[k] = info_defaults[k]
			}
		})

		d.info.estagio = { ...evento_defaults, ...(d.info.estagio || {}) }
		Object.keys(evento_defaults).forEach(k => {
			if (d.info.estagio[k] === null || d.info.estagio[k] === undefined) d.info.estagio[k] = ''
		})

		d.info.competicao_evento = { ...evento_defaults, ...(d.info.competicao_evento || {}) }
		Object.keys(evento_defaults).forEach(k => {
			if (d.info.competicao_evento[k] === null || d.info.competicao_evento[k] === undefined) d.info.competicao_evento[k] = ''
		})

		d.info.responsavel = { ...info_defaults.responsavel, ...(d.info.responsavel || {}) }
		Object.keys(info_defaults.responsavel).forEach(k => {
			if (d.info.responsavel[k] === null || d.info.responsavel[k] === undefined) {
				d.info.responsavel[k] = ''
			}
		})

		return d
	}

	const clean_data = () => {
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		set_dados(dados.current = ensure_defaults(dados.current))
	}

	const fetch_id_info = async (id_serch) => {
		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = ensure_defaults(res.data[0]));
			})
			.catch(error => console.log(error))
	}

	const item_id = props?.location?.state?.item?.id
	const operation = props?.location?.state?.operation

	useEffect(() => {
		clean_data();

		set_lang(localStorage.getItem('lang'))

		if (operation === 'edit' && item_id) {
			set_is_edit(true)
			set_show_delete_button(true)

			fetch_id_info(item_id).then(() => {
				setLoading(false)
			})
			return
		}

		clean_data()
		setLoading(false);
		setRedirect(false);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [item_id, operation])

	const handle_change_info = (e) => {
		const { name, value } = e.target;
		set_dados(dados.current.info[name] = value)
	}

	const handle_change_responsavel = (e) => {
		const { name, value } = e.target;
		set_dados(dados.current.info.responsavel[name] = value)
	}

	const handle_change_estagio = (e) => {
		const { name, value } = e.target;
		set_dados(dados.current.info.estagio[name] = value)
	}

	const handle_change_competicao_evento = (e) => {
		const { name, value } = e.target;
		set_dados(dados.current.info.competicao_evento[name] = value)
	}

	const change_competicao = (e) => {
		const id = e.target.value
		const found = competicoes_lista.find(c => String(c.id) === String(id))
		set_dados(dados.current.info.competicao_id = id)
		set_dados(dados.current.info.competicao_label = found ? (found?.info?.name ?? found?.name ?? '') : '')
	}

	const change_tipo_convocatoria = (selected) => {
		set_dados(dados.current.info.tipo_convocatoria = selected ? selected.value : '');
	};

	const change_modalidade = (selected) => {
		set_dados(dados.current.info.modalidade = selected ? selected.value : '');
	};

	const change_escaloes = (selected) => {
		set_dados(dados.current.info.escaloes = selected || []);
	};

	// ================= DOCUMENTOS (Regulamento / Relatório) =================
	const uploadFile = async (file, field) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'content')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/content/');

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then((res) => {
				const file_meta = {
					name: file.name,
					type: file.type,
					size: file.size,
					path: res.data.path,
					source_name: res.data.name,
					link: res.data.path + '' + res.data.name,
				};

				set_dados(dados.current.info[field] = [file_meta]);

				reqPUT(`${api_crud_route}/${getTokenInfo().companycode}`, dados.current)
					.then(() => { })
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

				return true
			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}

	const onChangeHandlerFilesDoc = (e) => {
		const { files, dataset } = e.target;
		const { field } = dataset;

		let filesArray = Array.prototype.slice.call(files);
		let storedFiles = [];

		filesArray.forEach((v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);
			}
			else {
				Swal.fire((language[lang].upload_file_error ?? 'Formato do ficheiro incorrecto: ') + v.name, '', 'info')
			}
		});

		if (storedFiles.length > 0) {
			let files_aux = files_doc
			files_aux.push({ files: storedFiles, field: field })
			set_files_doc(files_aux)
			setRefresh(refresh + 1)
		}
	}

	const uploadFilesDoc = async (files, field) => {
		files.forEach((element) => {
			if (element.type === 'application/pdf') {
				uploadFile(element, field).then(() => { })
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const handleDocRemove = (field) => {
		set_dados(dados.current.info[field] = [])
		setRefresh(refresh + 1)
	};

	// ================= CLUBES INSCRITOS =================
	const search_clubes_to_inscrever = async (term) => {
		setClubeLoading(true)
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/Clube`)
			const t = (term || '').toLowerCase()
			const ja_inscritos = (dados.current.info.clubes_inscritos || []).map(c => String(c.id))
			const filtered = (res.data || [])
				.filter(e => !ja_inscritos.includes(String(e.id)))
				.filter(e => {
					const nome = (e?.info?.name ?? e?.name ?? '').toLowerCase()
					return t === '' || nome.includes(t)
				})
			setClubeResults(filtered)
		} catch (error) {
			console.error('Erro ao pesquisar clubes:', error)
		} finally {
			setClubeLoading(false)
		}
	}

	useEffect(() => {
		if (showClubeModal) {
			search_clubes_to_inscrever(clubeSearch)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showClubeModal])

	const handle_clube_search_change = (e) => {
		const value = e.target.value
		setClubeSearch(value)
		search_clubes_to_inscrever(value)
	}

	const handleCloseClubeModal = () => {
		setShowClubeModal(false)
		setSelectedClubeToInscrever(null)
		setClubeSearch('')
	}

	const inscrever_clube = () => {
		if (!selectedClubeToInscrever) return

		const nome_clube = selectedClubeToInscrever?.info?.name ?? selectedClubeToInscrever?.name ?? ''

		Swal.fire({
			title: language[lang].inscrever_clube_title ?? 'Inscrever clube',
			html: `${language[lang].inscrever_clube_text ?? 'Confirma inscrever o clube'} <b>${nome_clube}</b> ${language[lang].inscrever_clube_text_2 ?? 'nesta convocatória?'}`,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].associar_confirm ?? 'Inscrever',
			cancelButtonText: language[lang].associar_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				const atual = dados.current.info.clubes_inscritos || []
				set_dados(dados.current.info.clubes_inscritos = [
					...atual,
					{ id: selectedClubeToInscrever.id, label: nome_clube }
				])
				handleCloseClubeModal()
			}
		})
	}

	const remover_clube_inscrito = (clube_id) => {
		Swal.fire({
			title: language[lang].remove_title ?? 'Remover',
			text: language[lang].remove_text ?? 'Confirma remover este clube da convocatória?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].remove_confirm ?? 'Remover',
			cancelButtonText: language[lang].remove_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				set_dados(dados.current.info.clubes_inscritos = (dados.current.info.clubes_inscritos || []).filter(c => String(c.id) !== String(clube_id)))

				if (String(selected_clube_inscrito?.id) === String(clube_id)) {
					set_selected_clube_inscrito(null)
				}
			}
		})
	}

	// ================= ATLETAS INSCRITOS =================
	const search_atletas_to_inscrever = async (term) => {
		if (!selected_clube_inscrito) {
			setAtletaResults([])
			return
		}

		setAtletaLoading(true)
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/special/${getTokenInfo().companycode}/*`)
			const t = (term || '').toLowerCase()
			const ja_inscritos = (dados.current.info.atletas_inscritos || []).map(a => String(a.id))
			const modalidades_convocatoria = dados.current.info.modalidade ? [dados.current.info.modalidade] : []
			const escaloes_convocatoria = (dados.current.info.escaloes || []).map(esc => esc.value ?? esc)

			const filtered = (res.data || [])
				.filter(e => !ja_inscritos.includes(String(e.id)))
				.filter(e => !clube_ids.has(String(e.id)))
				.filter(e => {
					const clube_entidade = e?.info?.clube ?? e?.clube
					const clube_entidade_id = clube_entidade?.id ?? clube_entidade
					const clube_entidade_label = clube_entidade?.label
					return String(clube_entidade_id) === String(selected_clube_inscrito.id)
						|| (clube_entidade_label && clube_entidade_label === selected_clube_inscrito.label)
				})
				.filter(e => {
					const nome = (e?.info?.name ?? e?.name ?? '').toLowerCase()
					return t === '' || nome.includes(t)
				})
				.filter(e => entidade_pratica_modalidade(e, modalidades_convocatoria))
				.filter(e => entidade_esta_no_escalao(e, modalidades_convocatoria, escaloes_convocatoria))

			setAtletaResults(filtered)
		} catch (error) {
			console.error('Erro ao pesquisar atletas:', error)
		} finally {
			setAtletaLoading(false)
		}
	}

	useEffect(() => {
		if (showAtletaModal) {
			search_atletas_to_inscrever(atletaSearch)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showAtletaModal, selected_clube_inscrito])

	const handle_atleta_search_change = (e) => {
		const value = e.target.value
		setAtletaSearch(value)
		search_atletas_to_inscrever(value)
	}

	const handleCloseAtletaModal = () => {
		setShowAtletaModal(false)
		setSelectedAtletaToInscrever(null)
		setAtletaSearch('')
	}

	const inscrever_atleta = () => {
		if (!selectedAtletaToInscrever || !selected_clube_inscrito) return

		const nome_atleta = selectedAtletaToInscrever?.info?.name ?? selectedAtletaToInscrever?.name ?? ''
		const numero_atleta = selectedAtletaToInscrever?.info?.numero_atleta ?? selectedAtletaToInscrever?.numero_atleta ?? ''
		const modalidades_convocatoria = dados.current.info.modalidade ? [dados.current.info.modalidade] : []
		const overlapping = get_overlapping_modalidades(selectedAtletaToInscrever, modalidades_convocatoria)
		const modalidades_label = overlapping.map(v => modalidades_lista.find(o => o.value === v)?.label ?? v).join(', ')
		const escalao_atleta = calcular_escalao_entidade(selectedAtletaToInscrever, modalidades_convocatoria)

		Swal.fire({
			title: language[lang].inscrever_atleta_title ?? 'Inscrever atleta',
			html: `${language[lang].inscrever_atleta_text ?? 'Confirma inscrever o atleta'} <b>${nome_atleta}</b> ${language[lang].inscrever_clube_text_2 ?? 'nesta convocatória?'}`,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].associar_confirm ?? 'Inscrever',
			cancelButtonText: language[lang].associar_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				const atual = dados.current.info.atletas_inscritos || []
				set_dados(dados.current.info.atletas_inscritos = [
					...atual,
					{
						id: selectedAtletaToInscrever.id,
						label: nome_atleta,
						numero_atleta: numero_atleta,
						escalao: escalao_atleta,
						modalidades: modalidades_label,
						clube_id: selected_clube_inscrito.id,
					}
				])
				handleCloseAtletaModal()
			}
		})
	}

	const remover_atleta_inscrito = (atleta_id) => {
		Swal.fire({
			title: language[lang].remove_title ?? 'Remover',
			text: language[lang].remove_text ?? 'Confirma remover este atleta da convocatória?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].remove_confirm ?? 'Remover',
			cancelButtonText: language[lang].remove_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				set_dados(dados.current.info.atletas_inscritos = (dados.current.info.atletas_inscritos || []).filter(a => String(a.id) !== String(atleta_id)))
			}
		})
	}

	// ================= AGENTES / TREINADORES / DIRIGENTES (pesquisa simples) =================
	const search_person = async (term) => {
		if (!personCategory) return
		setPersonLoading(true)
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/special/${getTokenInfo().companycode}/*`)
			const t = (term || '').toLowerCase()
			const field = PERSON_CATEGORIES[personCategory].field
			const ja_inscritos = (dados.current.info[field] || []).map(p => String(p.id))

			const filtered = (res.data || [])
				.filter(e => !ja_inscritos.includes(String(e.id)))
				.filter(e => !clube_ids.has(String(e.id)))
				.filter(e => {
					const nome = (e?.info?.name ?? e?.name ?? '').toLowerCase()
					return t === '' || nome.includes(t)
				})

			setPersonResults(filtered)
		} catch (error) {
			console.error('Erro ao pesquisar:', error)
		} finally {
			setPersonLoading(false)
		}
	}

	useEffect(() => {
		if (showPersonModal) {
			search_person(personSearch)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showPersonModal, personCategory])

	const openPersonModal = (category) => {
		setPersonCategory(category)
		setPersonSearch('')
		setSelectedPerson(null)
		setShowPersonModal(true)
	}

	const handle_person_search_change = (e) => {
		const value = e.target.value
		setPersonSearch(value)
		search_person(value)
	}

	const handleClosePersonModal = () => {
		setShowPersonModal(false)
		setPersonCategory(null)
		setSelectedPerson(null)
		setPersonSearch('')
	}

	const inscrever_person = () => {
		if (!selectedPerson || !personCategory) return

		const nome = selectedPerson?.info?.name ?? selectedPerson?.name ?? ''
		const field = PERSON_CATEGORIES[personCategory].field

		Swal.fire({
			title: language[lang].inscrever_pessoa_title ?? 'Inscrever',
			html: `${language[lang].inscrever_pessoa_text ?? 'Confirma inscrever'} <b>${nome}</b> ${language[lang].inscrever_clube_text_2 ?? 'nesta convocatória?'}`,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].associar_confirm ?? 'Inscrever',
			cancelButtonText: language[lang].associar_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				const atual = dados.current.info[field] || []
				set_dados(dados.current.info[field] = [...atual, { id: selectedPerson.id, label: nome }])
				handleClosePersonModal()
			}
		})
	}

	const remover_person = (category, person_id) => {
		const field = PERSON_CATEGORIES[category].field
		Swal.fire({
			title: language[lang].remove_title ?? 'Remover',
			text: language[lang].remove_text ?? 'Confirma remover este registo da convocatória?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].remove_confirm ?? 'Remover',
			cancelButtonText: language[lang].remove_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				set_dados(dados.current.info[field] = (dados.current.info[field] || []).filter(p => String(p.id) !== String(person_id)))
			}
		})
	}

	// ================= GRAVAR / ELIMINAR =================
	const handleSubmit = async (e) => {
		e.preventDefault();

		Swal.fire({
			title: is_edit ? (language[lang].edit_title ?? 'Editar') : (language[lang].insert_title ?? 'Inserir'),
			text: is_edit ? (language[lang].edit_text ?? 'Confirma a edição?') : (language[lang].insert_text ?? 'Confirma a inserção?'),
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: is_edit ? (language[lang].edit_confirm ?? 'Confirmar') : (language[lang].insert_confirm ?? 'Confirmar'),
			cancelButtonText: is_edit ? (language[lang].edit_cancel ?? 'Cancelar') : (language[lang].insert_cancel ?? 'Cancelar')
		}).then((result) => {
			if (result.isConfirmed) {

				const requestMethod = is_edit ? reqPUT : reqPOST

				requestMethod(`${api_crud_route}`, dados.current)
					.then(() => {
						files_doc.forEach(async (el_doc) => {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.field)
							}
						})
						set_files_doc([])

						props.history.push(endpoints.list)
					})
					.catch(() => Swal.fire(is_edit ? (language[lang].edit_error ?? 'Erro ao editar') : (language[lang].insert_error ?? 'Erro ao inserir'), '', 'info'))
			}
		})
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title ?? 'Eliminar',
			text: language[lang].delete_text ?? 'Confirma a eliminação?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm ?? 'Eliminar',
			cancelButtonText: language[lang].delete_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route + '/', { id: dados.current.id })
					.then(() => { props.history.push(endpoints.list); })
					.catch(() => Swal.fire(language[lang].delete_error ?? 'Erro ao eliminar', '', 'info'))
			}
		})
	};

	const mostra_estagio = dados.current && (dados.current.info.tipo_convocatoria === 'estagio' || dados.current.info.tipo_convocatoria === 'estagio_competicao')
	const mostra_competicao_evento = dados.current && (dados.current.info.tipo_convocatoria === 'competicao' || dados.current.info.tipo_convocatoria === 'estagio_competicao')

	return isloading ?

		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:

			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].convocatoria ?? 'Convocatória'}</h2>
					<p>{language[lang].convocatoria ?? 'Convocatória'} / {dados.current.id !== '' ? (language[lang].entity_edit ?? 'Editar') : (language[lang].entity_new ?? 'Novo')}</p>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="mb-5 mb-xl-10">

								{/* --- Dados da Convocatória --- */}
								<div className="card">
									<div className="card-header border-0">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].dados_convocatoria ?? 'Dados da Convocatória'}</h3>
										</div>
									</div>
									<div className="collapse show">
										<form id="form" onSubmit={handleSubmit}>
											<div className="card-body border-top p-4">

												<div className="row g-3 mb-4">
													<div className="col-md-6">
														<label className="form-label fw-bold fs-6">{language[lang].competicao ?? 'Competição'}</label>
														<select
															className="form-select"
															name="competicao_id"
															value={dados.current.info.competicao_id}
															onChange={change_competicao}
														>
															<option value="">{language[lang].select ?? 'Selecione'}</option>
															{competicoes_lista.map((c) => (
																<option key={c.id} value={c.id}>{c?.info?.name ?? c?.name}</option>
															))}
														</select>
													</div>

													<div className="col-md-6">
														<label className="form-label fw-bold fs-6">{language[lang].convocatoria ?? 'Convocatória'}</label>
														<input type="text" name="name" value={dados.current.info.name} className="form-control rounded-0" placeholder={language[lang].convocatoria_placeholder ?? 'Nome da convocatória'} onChange={handle_change_info} required />
													</div>
												</div>

												<div className="row g-3 mb-4">
													<div className="col-md-4">
														<label className="form-label fw-bold fs-6">{language[lang].tipo_convocatoria ?? 'Tipo de Convocatória'}</label>
														<Select
															className="div-select"
															options={tipo_convocatoria_lista}
															value={tipo_convocatoria_lista.find(o => o.value === dados.current.info.tipo_convocatoria) ?? null}
															placeholder={language[lang].select ?? 'Selecione'}
															onChange={change_tipo_convocatoria}
														/>
													</div>

													<div className="col-md-4">
														<label className="form-label fw-bold fs-6">{language[lang].epoca ?? 'Época'}</label>
														<input type="text" name="epoca" value={dados.current.info.epoca} className="form-control rounded-0" placeholder="2025/2026" onChange={handle_change_info} />
													</div>

													<div className="col-md-4">
														<label className="form-label fw-bold fs-6">{language[lang].modalidade ?? 'Modalidade'}</label>
														<Select
															className="div-select"
															options={modalidades_lista}
															value={modalidades_lista.find(o => o.value === dados.current.info.modalidade) ?? null}
															placeholder={language[lang].select ?? 'Selecione'}
															onChange={change_modalidade}
														/>
													</div>
												</div>

												<div className="row g-3 mb-4">
													<div className="col-md-12">
														<label className="form-label fw-bold fs-6">{language[lang].escaloes ?? 'Escalão(ões)'}</label>
														<Select
															isMulti
															className="div-select"
															options={escaloes_lista}
															value={
																Array.isArray(dados.current.info.escaloes)
																	? dados.current.info.escaloes.map(m => ({ label: m.label ?? m, value: m.value ?? m }))
																	: []
															}
															placeholder={language[lang].select ?? 'Selecione'}
															onChange={change_escaloes}
														/>
													</div>
												</div>

											</div>
										</form>
									</div>
								</div>

								{/* --- 1) Estágio --- */}
								{mostra_estagio && (
									<div className="card mt-5">
										<div className="card-header border-0">
											<div className="card-title m-0">
												<h3 className="fw-bolder m-0">{language[lang].estagio ?? '1) Estágio'}</h3>
											</div>
										</div>
										<div className="card-body border-top p-4">
											<div className="row g-3 mb-4">
												<div className="col-md-4">
													<label className="form-label fw-bold fs-6">{language[lang].data_saida ?? 'Data saída'}</label>
													<input type="date" name="data_saida" value={dados.current.info.estagio.data_saida} className="form-control rounded-0" onChange={handle_change_estagio} />
												</div>
												<div className="col-md-4">
													<label className="form-label fw-bold fs-6">{language[lang].inicio ?? 'Início'}</label>
													<input type="date" name="inicio" value={dados.current.info.estagio.inicio} className="form-control rounded-0" onChange={handle_change_estagio} />
												</div>
												<div className="col-md-4">
													<label className="form-label fw-bold fs-6">{language[lang].fim ?? 'Fim'}</label>
													<input type="date" name="fim" value={dados.current.info.estagio.fim} className="form-control rounded-0" onChange={handle_change_estagio} />
												</div>
											</div>

											<div className="row g-3 mb-4">
												<div className="col-md-4">
													<label className="form-label fw-bold fs-6">{language[lang].local_estagio ?? 'Local do estágio'}</label>
													<input type="text" name="local" value={dados.current.info.estagio.local} className="form-control rounded-0" onChange={handle_change_estagio} />
												</div>
												<div className="col-md-4">
													<label className="form-label fw-bold fs-6">{language[lang].localidade_estagio ?? 'Localidade estágio'}</label>
													<input type="text" name="localidade" value={dados.current.info.estagio.localidade} className="form-control rounded-0" onChange={handle_change_estagio} />
												</div>
												<div className="col-md-4">
													<label className="form-label fw-bold fs-6">{language[lang].pais_estagio ?? 'País estágio'}</label>
													<input type="text" name="pais" value={dados.current.info.estagio.pais} className="form-control rounded-0" onChange={handle_change_estagio} />
												</div>
											</div>

											<div className="row g-3 mb-4">
												<div className="col-md-4">
													<label className="form-label fw-bold fs-6">{language[lang].data_chegada_estagio ?? 'Data de chegada estágio'}</label>
													<input type="date" name="data_chegada" value={dados.current.info.estagio.data_chegada} className="form-control rounded-0" onChange={handle_change_estagio} />
												</div>
											</div>
										</div>
									</div>
								)}

								{/* --- 2) Competição --- */}
								{mostra_competicao_evento && (
									<div className="card mt-5">
										<div className="card-header border-0">
											<div className="card-title m-0">
												<h3 className="fw-bolder m-0">{language[lang].competicao_evento ?? '2) Competição'}</h3>
											</div>
										</div>
										<div className="card-body border-top p-4">
											<div className="row g-3 mb-4">
												<div className="col-md-4">
													<label className="form-label fw-bold fs-6">{language[lang].data_saida ?? 'Data saída'}</label>
													<input type="date" name="data_saida" value={dados.current.info.competicao_evento.data_saida} className="form-control rounded-0" onChange={handle_change_competicao_evento} />
												</div>
												<div className="col-md-4">
													<label className="form-label fw-bold fs-6">{language[lang].inicio ?? 'Início'}</label>
													<input type="date" name="inicio" value={dados.current.info.competicao_evento.inicio} className="form-control rounded-0" onChange={handle_change_competicao_evento} />
												</div>
												<div className="col-md-4">
													<label className="form-label fw-bold fs-6">{language[lang].fim ?? 'Fim'}</label>
													<input type="date" name="fim" value={dados.current.info.competicao_evento.fim} className="form-control rounded-0" onChange={handle_change_competicao_evento} />
												</div>
											</div>

											<div className="row g-3 mb-4">
												<div className="col-md-4">
													<label className="form-label fw-bold fs-6">{language[lang].local_competicao ?? 'Local da competição'}</label>
													<input type="text" name="local" value={dados.current.info.competicao_evento.local} className="form-control rounded-0" onChange={handle_change_competicao_evento} />
												</div>
												<div className="col-md-4">
													<label className="form-label fw-bold fs-6">{language[lang].local ?? 'Localidade'}</label>
													<input type="text" name="localidade" value={dados.current.info.competicao_evento.localidade} className="form-control rounded-0" onChange={handle_change_competicao_evento} />
												</div>
												<div className="col-md-4">
													<label className="form-label fw-bold fs-6">{language[lang].country ?? 'País'}</label>
													<input type="text" name="pais" value={dados.current.info.competicao_evento.pais} className="form-control rounded-0" onChange={handle_change_competicao_evento} />
												</div>
											</div>

											<div className="row g-3 mb-4">
												<div className="col-md-4">
													<label className="form-label fw-bold fs-6">{language[lang].data_chegada_competicao ?? 'Data de chegada competição'}</label>
													<input type="date" name="data_chegada" value={dados.current.info.competicao_evento.data_chegada} className="form-control rounded-0" onChange={handle_change_competicao_evento} />
												</div>
											</div>
										</div>
									</div>
								)}

								{/* --- Responsável / Relatório / Observações --- */}
								<div className="card mt-5">
									<div className="card-header border-0">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].responsavel ?? 'Responsável'}</h3>
										</div>
									</div>
									<div className="card-body border-top p-4">
										<div className="row g-3 mb-4">
											<div className="col-md-4">
												<label className="form-label fw-bold fs-6">{language[lang].responsavel_identificacao ?? 'Identi. Responsável'}</label>
												<input type="text" name="identificacao" value={dados.current.info.responsavel.identificacao ?? ''} className="form-control rounded-0" onChange={handle_change_responsavel} />
											</div>

											<div className="col-md-4">
												<label className="form-label fw-bold fs-6">{language[lang].responsavel_telefone ?? 'Tel Responsável'}</label>
												<PhoneInput
													defaultCountry="PT"
													className="form-control rounded-0"
													value={dados.current.info.responsavel.telefone || null}
													onChange={(valor) => set_dados(dados.current.info.responsavel.telefone = valor)}
												/>
											</div>

											<div className="col-md-4">
												<label className="form-label fw-bold fs-6">{language[lang].responsavel_email ?? 'e-mail Responsável'}</label>
												<input type="email" name="email" pattern={pattern_email} value={dados.current.info.responsavel.email ?? ''} className="form-control rounded-0" onChange={handle_change_responsavel} />
											</div>
										</div>

										<hr className="my-4" />

										<div className="row g-3 mb-4">
											<div className="col-md-6">
												<DocUploadField
													field="relatorio"
													label={language[lang].relatorio ?? 'Relatório da competição/estágio'}
													dados={dados}
													language={language}
													lang={lang}
													onChangeHandlerFilesDoc={onChangeHandlerFilesDoc}
													handleDocRemove={handleDocRemove}
												/>
											</div>

											<div className="col-md-6">
												<label className="form-label fw-bold fs-6">{language[lang].observacoes ?? 'Observações'}</label>
												<textarea name="observacoes" value={dados.current.info.observacoes} className="form-control rounded-0" rows="3" onChange={handle_change_info} />
											</div>
										</div>
									</div>
								</div>

								{is_edit && (
								<>
									{/* --- Clubes Inscritos --- */}
									<div className="card mt-5">
										<div className="card-header border-0 d-flex justify-content-between align-items-center">
											<div className="card-title m-0">
												<h3 className="fw-bolder m-0">{language[lang].clubes_inscritos ?? 'Clubes Inscritos'}</h3>
											</div>
											<button type="button" className="btn btn-sm btn-primary" onClick={() => setShowClubeModal(true)}>
												<i className="bi bi-plus-circle me-2"></i>
												{language[lang].inscrever_clube ?? 'Inscrever Clube'}
											</button>
										</div>
										<div className="card-body border-top p-4">
											<p className="text-muted small mb-3">
												{language[lang].selecionar_clube_hint ?? 'Selecione um clube na lista abaixo para gerir os atletas inscritos desse clube.'}
											</p>
											<table className="table table-bordered align-middle">
												<thead>
													<tr>
														<th>{language[lang].clube ?? 'Clube'}</th>
														<th></th>
													</tr>
												</thead>
												<tbody>
													{(dados.current.info.clubes_inscritos || []).length > 0 ? (
														dados.current.info.clubes_inscritos.map((el, k) => {
															const is_selected = String(selected_clube_inscrito?.id) === String(el.id)
															return (
																<tr
																	key={el.id ?? k}
																	onClick={() => set_selected_clube_inscrito(el)}
																	style={{ cursor: 'pointer', backgroundColor: is_selected ? '#e7f3ff' : undefined }}
																>
																	<td>
																		{is_selected && <i className="bi bi-check-circle-fill me-2" style={{ color: '#0095e8' }}></i>}
																		{el.label}
																	</td>
																	<td className="text-end">
																		<button
																			type="button"
																			className="btn btn-sm"
																			style={{ backgroundColor: '#d9214e', color: '#FFF' }}
																			onClick={(e) => { e.stopPropagation(); remover_clube_inscrito(el.id) }}
																		>
																			{language[lang].remove ?? 'Remover'}
																		</button>
																	</td>
																</tr>
															)
														})
													) : (
														<tr>
															<td colSpan="2" className="text-center text-muted">{language[lang].sem_registos ?? 'Sem registos'}</td>
														</tr>
													)}
												</tbody>
											</table>
										</div>
									</div>

									{/* --- Atletas Inscritos --- */}
									{selected_clube_inscrito && (
										<div className="card mt-5">
											<div className="card-header border-0 d-flex justify-content-between align-items-center">
												<div className="card-title m-0">
													<h3 className="fw-bolder m-0">
														{language[lang].atletas_inscritos ?? 'Atletas Inscritos'} — {selected_clube_inscrito.label}
													</h3>
												</div>
												<button type="button" className="btn btn-sm btn-primary" onClick={() => setShowAtletaModal(true)}>
													<i className="bi bi-plus-circle me-2"></i>
													{language[lang].inscrever_atletas ?? 'Inscrever Atletas'}
												</button>
											</div>
											<div className="card-body border-top p-4">
												<table className="table table-bordered align-middle">
													<thead>
														<tr>
															<th>{language[lang].numero_atleta ?? 'Nº de Atleta'}</th>
															<th>{language[lang].name ?? 'Nome'}</th>
															<th>{language[lang].escalao ?? 'Escalão'}</th>
															<th>{language[lang].modalidades ?? 'Modalidades'}</th>
															<th></th>
														</tr>
													</thead>
													<tbody>
														{(() => {
															const atletas_do_clube = (dados.current.info.atletas_inscritos || [])
																.filter(el => String(el.clube_id) === String(selected_clube_inscrito.id))

															if (atletas_do_clube.length === 0) {
																return (
																	<tr>
																		<td colSpan="5" className="text-center text-muted">{language[lang].sem_registos ?? 'Sem registos'}</td>
																	</tr>
																)
															}

															return atletas_do_clube.map((el, k) => (
																<tr key={el.id ?? k}>
																	<td>{el.numero_atleta}</td>
																	<td>{el.label}</td>
																	<td>{el.escalao || '-'}</td>
																	<td>{el.modalidades || '-'}</td>
																	<td className="text-end">
																		<button type="button" className="btn btn-sm" style={{ backgroundColor: '#d9214e', color: '#FFF' }} onClick={() => remover_atleta_inscrito(el.id)}>
																			{language[lang].remove ?? 'Remover'}
																		</button>
																	</td>
																</tr>
															))
														})()}
													</tbody>
												</table>
											</div>
										</div>
									)}

									{/* --- Agentes Desportivos / Treinadores / Dirigentes --- */}
									{Object.entries(PERSON_CATEGORIES).map(([cat, cfg]) => (
										<PersonListCard
											key={cat}
											category={cat}
											config={cfg}
											items={dados.current.info[cfg.field] || []}
											language={language}
											lang={lang}
											onAdd={() => openPersonModal(cat)}
											onRemove={(id) => remover_person(cat, id)}
										/>
									))}

								</>
								)}

								{/* --- Modal: Inscrever Clube --- */}
								{showClubeModal && (
									<div style={modalStyles.modalOverlay} onClick={handleCloseClubeModal}>
										<div style={modalStyles.modalContent} onClick={(e) => e.stopPropagation()}>
											<div style={modalStyles.taskListContainer}>
												<label className="form-label fw-bold fs-6">{language[lang].pesquisar_clube ?? 'Pesquisar Clube'}</label>
												<input
													type="text"
													className="form-control mb-3"
													placeholder={language[lang].pesquisar_entidade_placeholder ?? 'Pesquisar por nome...'}
													value={clubeSearch}
													onChange={handle_clube_search_change}
												/>

												<select
													className="form-select"
													size={8}
													value={selectedClubeToInscrever?.id ?? ''}
													onChange={(e) => {
														const found = clubeResults.find(el => String(el.id) === String(e.target.value))
														setSelectedClubeToInscrever(found ?? null)
													}}
												>
													<option value="">
														{clubeLoading ? (language[lang].loading ?? 'A carregar...') : (language[lang].field_choose ?? 'Selecione')}
													</option>
													{clubeResults.map((el, k) => (
														<option key={el.id ?? k} value={el.id}>
															{el.info?.name ?? el.name}
														</option>
													))}
												</select>
											</div>

											<div style={modalStyles.buttonContainer}>
												<button type="button" onClick={handleCloseClubeModal}>
													{language[lang].cancel ?? 'Cancelar'}
												</button>
												<button
													type="button"
													style={{ ...modalStyles.closeButton, marginLeft: '10px', backgroundColor: color.corPrimaria?.hexa ?? '#0095e8', color: '#FFF' }}
													disabled={!selectedClubeToInscrever}
													onClick={inscrever_clube}
												>
													{language[lang].inscrever_clube ?? 'Inscrever'}
												</button>
											</div>
										</div>
									</div>
								)}

								{/* --- Modal: Inscrever Atletas --- */}
								{showAtletaModal && (
									<div style={modalStyles.modalOverlay} onClick={handleCloseAtletaModal}>
										<div style={modalStyles.modalContent} onClick={(e) => e.stopPropagation()}>
											<div style={modalStyles.taskListContainer}>
												<label className="form-label fw-bold fs-6">{language[lang].pesquisar_atleta ?? 'Pesquisar Atleta'}</label>
												<input
													type="text"
													className="form-control mb-3"
													placeholder={language[lang].pesquisar_entidade_placeholder ?? 'Pesquisar por nome...'}
													value={atletaSearch}
													onChange={handle_atleta_search_change}
												/>

												<select
													className="form-select"
													size={8}
													value={selectedAtletaToInscrever?.id ?? ''}
													onChange={(e) => {
														const found = atletaResults.find(el => String(el.id) === String(e.target.value))
														setSelectedAtletaToInscrever(found ?? null)
													}}
												>
													<option value="">
														{atletaLoading ? (language[lang].loading ?? 'A carregar...') : (language[lang].field_choose ?? 'Selecione')}
													</option>
													{atletaResults.map((el, k) => (
														<option key={el.id ?? k} value={el.id}>
															{el.info?.name ?? el.name}
														</option>
													))}
												</select>
											</div>

											<div style={modalStyles.buttonContainer}>
												<button type="button" onClick={handleCloseAtletaModal}>
													{language[lang].cancel ?? 'Cancelar'}
												</button>
												<button
													type="button"
													style={{ ...modalStyles.closeButton, marginLeft: '10px', backgroundColor: color.corPrimaria?.hexa ?? '#0095e8', color: '#FFF' }}
													disabled={!selectedAtletaToInscrever}
													onClick={inscrever_atleta}
												>
													{language[lang].inscrever_atletas ?? 'Inscrever'}
												</button>
											</div>
										</div>
									</div>
								)}

								{/* --- Modal: Inscrever Pessoa (agentes/treinadores/dirigentes) --- */}
								{showPersonModal && (
									<div style={modalStyles.modalOverlay} onClick={handleClosePersonModal}>
										<div style={modalStyles.modalContent} onClick={(e) => e.stopPropagation()}>
											<div style={modalStyles.taskListContainer}>
												<label className="form-label fw-bold fs-6">
													{language[lang][PERSON_CATEGORIES[personCategory]?.title_key] ?? 'Pesquisar'}
												</label>
												<input
													type="text"
													className="form-control mb-3"
													placeholder={language[lang].pesquisar_entidade_placeholder ?? 'Pesquisar por nome...'}
													value={personSearch}
													onChange={handle_person_search_change}
												/>

												<select
													className="form-select"
													size={8}
													value={selectedPerson?.id ?? ''}
													onChange={(e) => {
														const found = personResults.find(el => String(el.id) === String(e.target.value))
														setSelectedPerson(found ?? null)
													}}
												>
													<option value="">
														{personLoading ? (language[lang].loading ?? 'A carregar...') : (language[lang].field_choose ?? 'Selecione')}
													</option>
													{personResults.map((el, k) => (
														<option key={el.id ?? k} value={el.id}>
															{el.info?.name ?? el.name}
														</option>
													))}
												</select>
											</div>

											<div style={modalStyles.buttonContainer}>
												<button type="button" onClick={handleClosePersonModal}>
													{language[lang].cancel ?? 'Cancelar'}
												</button>
												<button
													type="button"
													style={{ ...modalStyles.closeButton, marginLeft: '10px', backgroundColor: color.corPrimaria?.hexa ?? '#0095e8', color: '#FFF' }}
													disabled={!selectedPerson}
													onClick={inscrever_person}
												>
													{language[lang].associar_confirm ?? 'Inscrever'}
												</button>
											</div>
										</div>
									</div>
								)}

							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}>
										<i className="bi bi-chevron-left me-2"></i>
										<span>{language[lang].back ?? 'Voltar'}</span>
									</Link>
								</li>
								<li className={"nav-item " + (show_delete_button ? '' : 'd-none')}>
									<button type="button" onClick={() => apagar()} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete ?? 'Eliminar'}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save ?? 'Gravar'}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main>
}

// Campo de upload de PDF reutilizável
function DocUploadField({ field, label, dados, language, lang, onChangeHandlerFilesDoc, handleDocRemove }) {
	const current = dados?.current?.info?.[field];
	const hasFile = Array.isArray(current) && current.length > 0;

	return (
		<div className="p-3 bg-white shadow-sm rounded h-100">
			<label className="form-label fw-bold fs-6 d-block">{label}</label>

			{hasFile ? (
				<div className="d-flex align-items-center justify-content-between">
					<a href={current[0].link} target="_blank" rel="noreferrer" className="text-truncate">
						<i className="bi bi-file-earmark-pdf me-2"></i>
						{current[0].name}
					</a>
					<button
						type="button"
						onClick={() => handleDocRemove(field)}
						className="btn btn-sm ms-2"
						style={{ backgroundColor: '#d9214e', color: '#FFF', border: 'none', borderRadius: '5px' }}
					>
						X
					</button>
				</div>
			) : (
				<div className="text-muted mb-2">{language[lang].noFile ?? 'Sem ficheiro'}</div>
			)}

			<div className="mt-2">
				<input
					type="file"
					accept="application/pdf"
					data-field={field}
					onChange={onChangeHandlerFilesDoc}
					className="d-none"
					id={`doc-upload-${field}`}
				/>
				<label htmlFor={`doc-upload-${field}`} className="btn btn-outline-primary btn-sm">
					{language[lang].doc_choose ?? 'Escolher ficheiro'}
				</label>
			</div>
		</div>
	);
}

// Card reutilizável para Agentes Desportivos / Treinadores / Dirigentes
function PersonListCard({ category, config, items, language, lang, onAdd, onRemove }) {
	return (
		<div className="card mt-5">
			<div className="card-header border-0 d-flex justify-content-between align-items-center">
				<div className="card-title m-0">
					<h3 className="fw-bolder m-0">{language[lang][config.title_key] ?? config.label_key}</h3>
				</div>
				<button type="button" className="btn btn-sm btn-primary" onClick={onAdd}>
					<i className="bi bi-plus-circle me-2"></i>
					{language[lang][`inscrever_${category}`] ?? (language[lang].inscrever_pessoa ?? 'Inscrever')}
				</button>
			</div>
			<div className="card-body border-top p-4">
				<table className="table table-bordered align-middle">
					<thead>
						<tr>
							<th>{language[lang].name ?? 'Nome'}</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{items.length > 0 ? (
							items.map((el, k) => (
								<tr key={el.id ?? k}>
									<td>{el.label}</td>
									<td className="text-end">
										<button type="button" className="btn btn-sm" style={{ backgroundColor: '#d9214e', color: '#FFF' }} onClick={() => onRemove(el.id)}>
											{language[lang].remove ?? 'Remover'}
										</button>
									</td>
								</tr>
							))
						) : (
							<tr>
								<td colSpan="2" className="text-center text-muted">{language[lang].sem_registos ?? 'Sem registos'}</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
		</div>
	);
}